import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { MenuComponent } from './views/menu/menu.component';
import { GalleryComponent } from './views/gallery/gallery.component';
import { AboutusComponent } from './views/aboutus/aboutus.component';
import { ContactComponent } from './views/contact/contact.component';
import { CartComponent } from './views/cart/cart.component';
import { SingleprodComponent } from './views/singleprod/singleprod.component';
import { CheckoutComponent } from './views/checkout/checkout.component';
import { TablenoComponent } from './views/tableno/tableno.component';
import { LoginComponent } from './views/login/login.component';
import { ChangenoComponent } from './views/changeno/changeno.component';
import { AuthGuard } from './services/guards/auth.guard';
import { LoginGuard } from './services/guards/login.guard';
import { StartGuard } from './services/guards/start.guard';
import { CheckoutGuard } from './services/guards/checkout.guard';
import { CheckoutguardviewComponent } from './views/checkoutguardview/checkoutguardview.component';
import { GeneralReviewsComponent } from './views/general-reviews/general-reviews.component';
import { SwitcherComponent } from './dashboard/switcher/switcher.component';
import { DashboardLoginComponent } from './dashboard/dashboard-login/dashboard-login.component';
import { OrdersLoginComponent } from './dashboard/orders-login/orders-login.component';
import { DashboardPanelComponent } from './dashboard/dashboard-panel/dashboard-panel.component';
import { OrdersPanelComponent } from './dashboard/orders-panel/orders-panel.component';
import { DashboardPanalGuardGuard } from './services/guards/dashboard-panal-guard.guard';
import { OrdersPanalGuardGuard } from './services/guards/orders-panal-guard.guard';
import { OrdersLoginGuardGuard } from './services/guards/orders-login-guard.guard';
import { MustlogoutComponent } from './components/mustlogout/mustlogout.component';
import { OrdersPanalInstacComponent } from './dashboard/orders-panal-instac/orders-panal-instac.component';
import { AddMenuComponent } from './dashboard/add-menu/add-menu.component';
import { ViewUsersComponent } from './dashboard/view-users/view-users.component';
import { ViewReviewsComponent } from './dashboard/view-reviews/view-reviews.component';
import { AddCarouselComponent } from './dashboard/add-carousel/add-carousel.component';
import { AddGalleryComponent } from './dashboard/add-gallery/add-gallery.component';
import { ViewContactComponent } from './dashboard/view-contact/view-contact.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { CheckMailComponent } from './views/check-mail/check-mail.component';
import { LetsStartComponent } from './views/lets-start/lets-start.component';
import { CheckmailGuard } from './services/guards/checkmail.guard';
import { AddCrewComponent } from './dashboard/add-crew/add-crew.component';
import { ViewAboutComponent } from './dashboard/view-about/view-about.component';


const routes: Routes = [
  //User View
  { path: '', component: HomeComponent},
  { path: 'menu', component: MenuComponent,data: {state:  'menu'} },
  { path: 'gallery', component: GalleryComponent,data: {state:  'gallery'} },
  { path: 'about', component: AboutusComponent,data: {state:  'about'} },
  { path: 'contact', component: ContactComponent,data: {state:  'contact'} },
  { path: 'cart', component: CartComponent,canActivate: [AuthGuard,CheckoutGuard],data: {state:  'cart'} },
  { path: 'single/:id1/:id2', component: SingleprodComponent,data: {state:  'single'} },
  { path: 'checkout', component: CheckoutComponent,canActivate: [CheckoutGuard,AuthGuard],data: {state:  'checkout'} },
  { path: 'start', component: TablenoComponent,canActivate: [StartGuard],data: {state:  'start'} },
  { path: 'login', component: LoginComponent,canActivate: [LoginGuard],data: {state:  'login'} },
  { path: 'change-no', component: ChangenoComponent,data: {state:  'change-no'} },
  { path: 'checkout-guard', component: CheckoutguardviewComponent,data: {state:  'checkout-guard'} },
  { path: 'general-reviews', component: GeneralReviewsComponent,data: {state:  'general-reviews'},canActivate: [AuthGuard] },
  { path: 'must-logout', component: MustlogoutComponent,data: {state:  'must-logout'} },
  { path: 'check-mail', component: CheckMailComponent,canActivate: [CheckmailGuard],data: {state:  'check-mail'} },
  { path: 'true84188484a8s4dasd', component: LetsStartComponent,canActivate: [StartGuard],data: {state:  'true84188484a8s4dasd'} },
  // { path: '**', component: NotFoundComponent },

  //Admin
  { path: 'switcher', component: SwitcherComponent,data: {state:  'switcher'}  },
  // { path: 'dashboard-login', component: DashboardLoginComponent },
  { path: 'controls-panel-login', component: OrdersLoginComponent,canActivate: [OrdersLoginGuardGuard],data: {state:  'controls-panel-login'}  },

  //Orders Panel
  { path: 'orders-panel', component: OrdersPanelComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'orders-panel'}  },
  { path: 'op-instructions', component: OrdersPanalInstacComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'op-instructions'}  },

  //Dashboard
  { path: 'menus-panel', component: AddMenuComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'menus-panel'}  },
  { path: 'users-panel', component: ViewUsersComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'users-panel'}  },
  { path: 'reviews-panel', component: ViewReviewsComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'reviews-panel'}  },
  { path: 'carousel-panel', component: AddCarouselComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'carousel-panel'}  },
  { path: 'gallery-panel', component: AddGalleryComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'gallery-panel'}  },
  { path: 'crew-panel', component: AddCrewComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'gallery-panel'}  },
  { path: 'contact-panel', component: ViewContactComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'contact-panel'}  },
  { path: 'about-panel', component: ViewAboutComponent,canActivate:[OrdersPanalGuardGuard],data: {state:  'contact-panel'}  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
